export default __webpack_public_path__ + "static/orca-7d9ad72c3d03a4878fbede5ec82652a5.mp4";